module.exports = __webpack_public_path__ + "img/high-kickback.72246176.png";